export enum VIDEO_TYPE {
  DEPARTURE = 'departure',
  FACILITY = 'facility',
  ANNOUNCEMENT = 'announcement'
}
